export default __webpack_public_path__ + "static/media/PJL03.839b0daf.png";